<template>
    <div class="apprentice-simple-card row">
        <div class="col-md-12">
            <div class="form-group">
                <strong
                    ><label>{{ $t('common.title') }}</label></strong
                >
                <b-form-input
                    v-model="quest.name"
                    :placeholder="$t('quest.title_quest')"
                    @change="updateName"></b-form-input>
            </div>
        </div>

        <div class="col-md-12">
            <strong
                ><label>{{ $t('quest.explanation_quest') }}</label></strong
            >

            <ckeditor
                v-model="quest.description"
                :editor="editor"
                :config="editorConfig"></ckeditor>
            <button
                class="btn btn-primary btn-save float-right"
                type="button"
                @click="updateDescription()">
                {{ $t('quest.explanation_quest') }}
            </button>
        </div>

        <div class="col-md-12">
            <strong><label>Banner</label></strong>
            <b-alert
                show
                variant="info">
                {{ $t('quest.maximum_upload_size_mb', { megabytes: 3000 }) }}
            </b-alert>

            <p>
                {{ $t('quest.upload_banner') }}<br />
                ({{ $t('quest.max_height_and_width', { height: '240px', width: '2400px' }) }})
            </p>
            <b-form-file
                class="apprentice-file-upload quest-banner-image-upload"
                v-model="banner"
                accept=".jpg, .png, .jif. ,jfif"
                :placeholder="$t('quest.choose_image')"
                :drop-placeholder="$t('quest.choose_image')"
                @input="uploadBanner">
            </b-form-file>
        </div>
        <div
            class="col-md-12"
            v-if="quest.banner">
            <div class="banner-preview">
                <img
                    class="banner"
                    :src="quest.banner.path" />
            </div>
        </div>
    </div>
</template>

<script>
import ApprenticeEditor from '../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-quest-edit-general-component',
    props: ['questIn'],
    data() {
        return {
            quest: this.questIn,
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'insertTable',
                        '|',
                        'fontColor',
                        'fontFamily',
                        'fontSize',
                        'fontBackgroundColor',
                        'highlight',
                        'specialCharacters',
                        '|',
                        'horizontalLine',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            banner: null,
        };
    },
    methods: {
        updateName() {
            var data = {
                name: this.quest.name,
            };

            this.axios.post(this.routes.questEditName(this.quest.id), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        updateDescription() {
            var data = {
                description: this.quest.description,
            };

            this.alert.saving();

            this.axios.post(this.routes.questEditDescription(this.quest.id), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        uploadBanner() {
            let headers = { 'Content-Type': 'multipart/form-data' };
            let data = new FormData();
            data.append('file', this.banner);

            this.alert.saving();

            this.axios.post(this.routes.questEditBannerUpload(this.quest.id), data, { headers: headers }).then(
                (response) => {
                    this.quest = response.data.quest;

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        deleteBanner() {
            this.alert
                .confirm(this.$t('quest.delete_banner'), this.$t('quest.are_you_sure_you_want_to_delete_the_banner'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.questEditBannerDelete(this.questId)).then(
                            (response) => {
                                this.skills = this.skills.filter((skill) => skill.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.banner {
    margin-top: 20px;
    max-width: 100%;
}

.btn-save {
    margin-top: 30px;
}

.quest-banner-image-upload {
    height: 51px;
}

.banner-preview {
    max-height: 250px;
    height: 100%;
    width: 100%;

    img {
        object-fit: cover;
        object-position: center;
        height: 100%;
        width: 100%;
    }
}
</style>
